export const normalizeMusicTags = (rawTags) => {
  const tags = Array.isArray(rawTags)
    ? rawTags
    : (typeof rawTags === 'string' ? rawTags.split(',') : []);
  return tags
    .map((tag) => String(tag || '').trim().toLowerCase())
    .filter(Boolean);
};

/** 从音乐对象取文件名（不含路径与扩展名），用于纯音乐判断 */
export const getBaseFilenameWithoutExtension = (music) => {
  if (!music) return '';
  let name = '';
  if (music.file_name && typeof music.file_name === 'string') {
    const parts = String(music.file_name).split(/[/\\]/);
    name = parts[parts.length - 1] || '';
    name = name.replace(/\.[^/.]+$/, '');
  }
  if (!name && music.tags && Array.isArray(music.tags)) {
    const tag = music.tags.find((t) => String(t || '').startsWith('sourceFile='));
    if (tag) {
      name = String(tag).replace(/^sourceFile=/, '').trim();
      name = name.replace(/\.[^/.]+$/, '');
    }
  }
  return name.trim();
};

/** 仅通过文件名判断是否纯音乐：文件名（不含扩展名）以 MUSIC 开头或以 MUSIC 结尾 */
export const isInstrumentalMusic = (music) => {
  if (!music) return false;
  const base = getBaseFilenameWithoutExtension(music);
  if (!base) return false;
  const u = base.toUpperCase();
  return u.startsWith('MUSIC') || u.endsWith('MUSIC');
};

export const normalizeInstrumentalTitle = (music, rawTitle) => {
  const title = String(rawTitle || '').trim();
  if (!title) return '';
  if (!isInstrumentalMusic(music)) return title;
  const cleaned = title
    .replace(/·\s*MUSIC/gi, '')
    .replace(/MUSIC-/gi, '')
    .replace(/MUSIC/gi, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^[\s·\-–—]+|[\s·\-–—]+$/g, '')
    .trim();
  return cleaned || title;
};
